import { render, staticRenderFns } from "./connected-to-lax.vue?vue&type=template&id=69569ea2&scoped=true&"
import script from "./connected-to-lax.vue?vue&type=script&lang=js&"
export * from "./connected-to-lax.vue?vue&type=script&lang=js&"
import style0 from "./connected-to-lax.vue?vue&type=style&index=0&id=69569ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69569ea2",
  null
  
)

export default component.exports